import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** The public Dominion programme page, where a Free Participant can see what
 * the full programme adds. `VITE_DOMINION_URL`, else the app origin + `/dominion`. */
export function dominionUrl(): string {
  const configured = import.meta.env.VITE_DOMINION_URL;
  if (configured) return configured;
  const base = import.meta.env.VITE_APP_URL || window.location.origin;
  return `${new URL(base).origin}/dominion`;
}
